import {IonButton, IonText,} from '@ionic/react';
import * as React from 'react';

import Page from "../../../components/core/Page";
import './error-404-page.component.css';
import {useHistory} from "react-router";

type Props = {};

export const Error404Page: React.FC<Props> = _props => {
    const history = useHistory();

    const goToHome = () => {
        history.replace('/home'); // or whatever route you prefer
    };

    return (
        <Page className={"error-404-page"}
              title={'Page Not Found'}
              showMenuButton={true}
              showBackButton={false}
              showLoading={false}
        >
            <div className="ion-text-center">
                <IonText color="medium">
                    <h2>Oops! We couldn’t find what you were looking for.</h2>
                </IonText>
                <IonButton onClick={goToHome}>Go Home</IonButton>
            </div>
        </Page>
    );
};
